/**
 * @generated SignedSource<<8fa87513f57fa92fb755be77914e6efc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "padding"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pages"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "padding",
        "variableName": "padding"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      },
      {
        "kind": "Variable",
        "name": "variables",
        "variableName": "variables"
      }
    ],
    "concreteType": "UrlMutationResponse",
    "kind": "LinkedField",
    "name": "previewDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PreviewDocumentMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PreviewDocumentMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "2188de9456677022e72292897cb0376b",
    "id": null,
    "metadata": {},
    "name": "PreviewDocumentMutation",
    "operationKind": "mutation",
    "text": "mutation PreviewDocumentMutation(\n  $pages: [DocumentSectionInput!]!\n  $variables: String\n  $padding: PaddingInput\n  $documentId: ID\n) {\n  previewDocument(pages: $pages, variables: $variables, padding: $padding, documentId: $documentId) {\n    ok\n    error\n    url\n  }\n}\n"
  }
};
})();

node.hash = "bb49a4f769fadbb5d830d89e35139571";

export default node;
